var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 16.6667C14.1667 15.286 12.3012 14.1667 10 14.1667C7.69881 14.1667 5.83333 15.286 5.83333 16.6667M17.5 14.167C17.5 13.1418 16.4716 12.2608 15 11.875M2.5 14.167C2.5 13.1418 3.52841 12.2608 5 11.875M15 8.53009C15.5115 8.07232 15.8333 7.40708 15.8333 6.66667C15.8333 5.28595 14.714 4.16667 13.3333 4.16667C12.693 4.16667 12.109 4.40738 11.6667 4.80324M5 8.53009C4.48854 8.07232 4.16667 7.40708 4.16667 6.66667C4.16667 5.28595 5.28595 4.16667 6.66667 4.16667C7.30696 4.16667 7.89104 4.40738 8.33333 4.80324M10 11.6667C8.61929 11.6667 7.5 10.5474 7.5 9.16667C7.5 7.78595 8.61929 6.66667 10 6.66667C11.3807 6.66667 12.5 7.78595 12.5 9.16667C12.5 10.5474 11.3807 11.6667 10 11.6667Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTeams);
export default __webpack_public_path__ + "static/media/nav-teams.f31d610e2a3323dfafbf14c12bb73961.svg";
export { ForwardRef as ReactComponent };